module.exports = __webpack_public_path__ + "4645eec7b5b33898656e23f516c36946.png";